import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { BulbIcon } from 'foundations-assets/icons/components/BulbIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MarkdownText } from '../MarkdownText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ThinkingBlock({
  block
}) {
  const {
    text
  } = block;
  const renderContent = useCallback(() => {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      paddingInline: "400",
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(MarkdownText, {
          text: text
        })
      })
    });
  }, [text]);
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "thinking",
    children: /*#__PURE__*/_jsx(AccordionItem, {
      size: "extra-small",
      flush: true,
      animate: true,
      removeContentPadding: true,
      renderContent: renderContent,
      title: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(BulbIcon, {
          size: "300",
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "breezeEngineChatComponents.blocks.thinking"
          })
        })]
      })
    })
  });
}